module.exports = __webpack_public_path__ + "ae23c355614edb55b99c35d64aef9508.svg";